import React, { useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import FundraiserContest from '../sections/FundraiserContest';

const GoFundMeWidget = ({ campaignUrl }) => {
  const embedRef = useRef(null);

  useEffect(() => {
    const embedUrl = `${campaignUrl}/widget/medium`;
    const currentRef = embedRef.current;
    
    try {
      const iframe = document.createElement('iframe');
      iframe.src = embedUrl;
      iframe.style.width = '100%';
      iframe.style.height = '205px';
      iframe.style.border = 'none';
      iframe.title = 'GoFundMe Campaign Widget';
      
      if (currentRef) {
        currentRef.innerHTML = '';
        currentRef.appendChild(iframe);
      }
    } catch (err) {
      console.error('Error creating embed:', err);
    }

    return () => {
      if (currentRef) {
        currentRef.innerHTML = '';
      }
    };
  }, [campaignUrl]);

  return (
    <div ref={embedRef} className="w-full max-w-md mx-auto bg-white rounded-lg overflow-hidden shadow-lg" />
  );
};

const FundraiserPage = () => {
  // eslint-disable-next-line no-unused-vars
  const campaignUrl = "https://www.gofundme.com/f/help-hungry-students-with-raps4snacks";
  
  return (
    <>
      <Helmet>
        <title>SONNY.SOUF| RAPS-4-SNACKS</title>
        <meta name="description" content="Join SONNY.SOUF's RAPS-4-SNACKS challenge. Submit your hungriest verse and help provide meals to students in need. $100 prize for the winning submission." />
        
        {/* OpenGraph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="RAPS-4-SNACKS Community Fundraiser | SONNY.SOUF" />
        <meta property="og:description" content="Join SONNY.SOUF's RAPS-4-SNACKS challenge. Submit your hungriest verse and help provide meals to students in need. $100 prize for the winning submission." />
        <meta property="og:image" content="%PUBLIC_URL%/rap4snacks.png" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="RAPS-4-SNACKS Community Fundraiser | SONNY.SOUF" />
        <meta name="twitter:description" content="Join SONNY.SOUF's RAPS-4-SNACKS challenge. Submit your hungriest verse and help provide meals to students in need. $100 prize for the winning submission." />
        <meta name="twitter:image" content="%PUBLIC_URL%/rap4snacks-og.png" />
      </Helmet>

      <motion.div
        initial="initial"
        animate="animate"
        exit="exit"
        className="page-container"
      >
        {/* Header with Background */}
        <motion.div 
          className="w-full bg-[#1A1A1A] rounded-lg p-8 mb-16"
        >
          <div className="text-center mb-8">
            <h1 className="font-['Orbitron'] text-3xl text-white mb-4">
              SENDING OUT UNIQUE FREQUENCIES
            </h1>
            <p className="text-gray-300 text-sm">
              Contribute to our efforts of helping hungry students!
            </p>
          </div>
          
          {/* Main Content Section */}
          <div className="max-w-4xl mx-auto">
            {/* Video Section */}
            <div className="w-full bg-[#1A1A1A] rounded-lg overflow-hidden mb-8">
              <div className="relative pt-[56.25%]">
                <div 
                  className="sp-embed-player absolute top-0 left-0 w-full h-full" 
                  data-id="cZltYineITs"
                >
                  <iframe
                    className="absolute top-0 left-0 w-full h-full"
                    style={{ border: 0 }}
                    scrolling="no"
                    src="https://go.screenpal.com/player/cZltYineITs?width=100%&height=100%&ff=1&title=0"
                    allowFullScreen
                    title="RAPS-4-SNACKS Campaign Video"
                  />
                </div>
              </div>
            </div>

            {/* Medium GoFundMe Widget */}
            <div className="w-full flex justify-center mb-8">
              <GoFundMeWidget campaignUrl={campaignUrl} />
            </div>
          </div>
        </motion.div>

        {/* Fundraiser Contest Component */}
        <FundraiserContest />
      </motion.div>
    </>
  );
};

export default FundraiserPage;